import type { CurrentUserSearchConfig } from "./types"
import type { NextRequest } from "@/modules/fetch/types"
import type { I18nLocale } from "@/modules/i18n/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

import { CURRENT_USER_SEARCH_CONFIG_ENDPOINT } from "./constants"

type GetCurrentUserSearchConfigParams = {
  locale: I18nLocale
  req?: NextRequest
}

export const getCurrentUserSearchConfig = async (
  params: GetCurrentUserSearchConfigParams
): Promise<CurrentUserSearchConfig> => {
  const { locale, req } = params

  return fetcher(CURRENT_USER_SEARCH_CONFIG_ENDPOINT, {
    nextRequest: req,
    requestInit: {
      headers: {
        "Accept-Language": locale,
      },
    },
    serviceDomain: "KRAKEND_API",
  })
    .then(getResultFromResponse<CurrentUserSearchConfig>())
    .catch(handleFetchError(CURRENT_USER_SEARCH_CONFIG_ENDPOINT))
}
